import { transparentize } from 'polished'
import styled from 'styled-components'

import { ButtonAsync } from '@subaio/components'

import { helpers } from 'styles'

export const ButtonOutline = styled(ButtonAsync)`
	color: ${helpers.color.text};
	background-color: transparent;
	border: 1px solid ${helpers.color.text};
	font-family: ${helpers.font.family.header};
	font-size: ${helpers.font.size.base};
	margin: 0;

	border-radius: 12px;
	min-width: 125px;
	height: 40px;
	padding-left: 16px;
	padding-right: 16px;
	transition: color 150ms, background-color 150ms, border-color 150ms;
	isolation: isolate;

	&:is(:focus-visible, :hover) {
		background-color: ${({ theme }) => transparentize(0.88, theme.color.primaryLight)};
		color: ${helpers.color.primary};
		border-color: ${helpers.color.primary};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:disabled {
		background-color: ${helpers.color.disabledContrast};
		border-color: ${helpers.color.disabled};
		color: ${helpers.color.disabled};
	}
`
